/**
 * Campo de telefone do cadastro de contato (ContactModal): limpeza, formatação
 * e posição do cursor. Funções puras, sem React.
 *
 * DDD 55 (Santa Maria/RS) é igual ao código do Brasil. Por isso, quando o
 * número entra inteiro de uma vez (colado ou preenchido pelo navegador), o que
 * decide se o 55 da frente é o país é o TAMANHO: 10 ou 11 dígitos é sempre DDD
 * + número. Até 04/10/2026, "55 99698-8996" colado virava "+55 (99) ...".
 */

const onlyDigits = (raw) => String(raw || "").replace(/\D/g, "");

/** Limpa o que foi digitado tecla a tecla: o 55 do país entra na 1ª tecla. */
export const sanitizePhone = (raw) => {
  let digits = onlyDigits(raw);
  if (digits.startsWith("0")) digits = digits.substring(1);
  if (digits.length > 0 && !digits.startsWith("55")) digits = "55" + digits;
  if (digits.length > 13) digits = digits.substring(0, 13);
  return digits;
};

/**
 * Número que entrou inteiro de uma vez (campo vazio antes): 10 ou 11 dígitos
 * é DDD + número e ganha o 55, mesmo começando com 55 (DDD do RS).
 */
export const sanitizePastedPhone = (raw) => {
  let digits = onlyDigits(raw);
  if (digits.startsWith("0")) digits = digits.substring(1);
  if (digits.length === 10 || digits.length === 11) return "55" + digits;
  return sanitizePhone(digits);
};

export const formatPhoneDisplay = (raw) => {
  const digits = sanitizePhone(raw);
  if (digits.length === 0) return "";
  if (digits.length <= 2) return `+${digits}`;
  if (digits.length <= 4) return `+${digits.substring(0, 2)} (${digits.substring(2)}`;
  if (digits.length <= 9)
    return `+${digits.substring(0, 2)} (${digits.substring(2, 4)}) ${digits.substring(4)}`;
  if (digits.length <= 13) {
    const ddd = digits.substring(2, 4);
    const firstPart = digits.substring(4, digits.length - 4);
    const lastPart = digits.substring(digits.length - 4);
    return `+55 (${ddd}) ${firstPart}-${lastPart}`;
  }
  return digits;
};

/** Quantos dígitos existem antes da posição `caret` do texto. */
export const digitsBeforeCaret = (text, caret) =>
  onlyDigits(String(text || "").slice(0, Math.max(0, caret || 0))).length;

/**
 * Posição no texto formatado logo depois do N-ésimo dígito. Usada para o
 * cursor ficar onde a pessoa estava digitando: sem isso, cada reformatação
 * jogava o cursor para o fim e uma correção no meio do número ia parar no fim.
 */
export const caretAfterDigits = (formatted, count) => {
  if (count <= 0) {
    const first = String(formatted).search(/\d/);
    return first < 0 ? 0 : first;
  }
  let seen = 0;
  for (let i = 0; i < formatted.length; i += 1) {
    if (/\d/.test(formatted[i])) {
      seen += 1;
      if (seen === count) return i + 1;
    }
  }
  return formatted.length;
};
